import { render, staticRenderFns } from "./QuestionSection.vue?vue&type=template&id=a510b986&scoped=true&"
import script from "./QuestionSection.vue?vue&type=script&lang=js&"
export * from "./QuestionSection.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSection.vue?vue&type=style&index=0&id=a510b986&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a510b986",
  null
  
)

export default component.exports